import { useEffect, useState } from "react";

/**
 * Recent bekeken producten — alleen client-side (localStorage), geen tracking server-side.
 * Bewaart de laatst bekeken product-/glassoort-slugs (meest recent eerst).
 */
const KEY = "gt:recent";
const MAX = 12;

function read(): string[] {
  try {
    const raw = localStorage.getItem(KEY);
    const arr = raw ? JSON.parse(raw) : [];
    return Array.isArray(arr) ? arr.filter((s): s is string => typeof s === "string") : [];
  } catch {
    return [];
  }
}

/** Leg een bekeken slug vast (meest recent vooraan, dedup, max MAX). */
export function recordView(slug: string | undefined): void {
  if (!slug) return;
  try {
    const next = [slug, ...read().filter((s) => s !== slug)].slice(0, MAX);
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    /* localStorage niet beschikbaar — negeren */
  }
}

/** Recent bekeken slugs (gelezen na mount; SSR-/SPA-veilig). */
export function useRecentlyViewed(): string[] {
  const [slugs, setSlugs] = useState<string[]>([]);
  useEffect(() => setSlugs(read()), []);
  return slugs;
}
